import React from 'react'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'

import Link from '~/client/components/Link'
import Form from '~/client/components/Form'
import ErrorMessage from '~/client/components/ErrorMessage'
import AvatarInput from '~/client/components/AvatarInput'

export default function AppForm({
  onSubmit, submitting, submittable, error, value, onChange, submitText
}){
  const disabled = !!(submitting)
  return <Form {...{ onSubmit, disabled }}>
    <ErrorMessage error={error}/>
    <Stack direction="row" spacing={2}>
      <AvatarInput {...{
        disabled,
        value: value.logo || '',
        onChange: logo => { onChange({ logo }) },
        circular: true,
      }}/>
      <TextField
        disabled={disabled}
        required
        autoFocus
        label="Application Name"
        helperText="Something users will recognize and trust."
        margin="normal"
        fullWidth
        name="name"
        type="name"
        value={value.name || ''}
        onChange={e => { onChange({ name: e.target.value }) }}
      />
    </Stack>
    <TextField
      disabled={disabled}
      required
      label="Homepage url"
      helperText="The full URL to your application homepage."
      margin="normal"
      fullWidth
      type="url"
      value={value.homepageUrl || ''}
      onChange={e => { onChange({ homepageUrl: e.target.value }) }}
    />
    <TextField
      disabled={disabled}
      required
      label="Description"
      helperText="This is displayed to all users of your application."
      margin="normal"
      fullWidth
      multiline
      name="description"
      value={value.description || ''}
      onChange={e => { onChange({ description: e.target.value }) }}
    />
    <TextField
      disabled={disabled}
      required
      label="Authorization callback URL"
      helperText={<>
        Your application’s callback URL. Read our <Link to="https://docs.jlinx.io/oauth">OAuth documentation</Link> for more information.
      </>}
      margin="normal"
      fullWidth
      type="url"
      value={value.callbackUrl || ''}
      onChange={e => { onChange({ callbackUrl: e.target.value }) }}
    />
    <TextField
      disabled={disabled}
      label="Webhook URL"
      helperText={<>
        You applications' Webhooks URL. Read our <Link to="https://docs.jlinx.io/webooks">Webhooks documentation</Link> for more information.
      </>}
      margin="normal"
      fullWidth
      type="url"
      value={value.webhookUrl || ''}
      onChange={e => { onChange({ webhookUrl: e.target.value }) }}
    />
    <Stack spacing={2} direction="row-reverse" alignItems="center" mt={2}>
      <Button
        disabled={disabled || !submittable}
        type="submit"
        variant="contained"
        size="large"
      >{submitText[submitting ? 1 : 0]}</Button>
      <Link
        variant="text"
        disabled={disabled}
        onClick={() => { onChange(undefined, true) }}
      >reset</Link>
      {/*<Link*/}
      {/*  variant="text"*/}
      {/*  to="/apps"*/}
      {/*>cancel</Link>*/}
    </Stack>
  </Form>
}
